const environtment = process.env.NODE_CONFIG_ENV || 'staging'
const isProduction = environtment === 'production'

const productionConfig = require('./production')
const stagingConfig = require('./staging')
/** @type {import('./index').Config } */
const currentConfig = isProduction ? productionConfig : stagingConfig
module.exports = currentConfig
